import React from 'react';
import { View, Text } from 'react-native';
import Svg, { Path } from 'react-native-svg';
import { useTheme } from '../../../src/theme/useTheme';
import { getSketchNoteStyles } from './SketchNote.styles';

export type SketchNoteSide = 'center' | 'right';

export interface SketchNoteProps {
  text: string;
  /** Which way the note (and its arrow) leans relative to the card above. */
  side?: SketchNoteSide;
}

/** Hand-drawn arrow glyph pointing up toward the card (verbatim from the design). */
const ARROW_PATH = 'M30 34 C 28 16, 14 14, 6 4 M6 4 L15 7 M6 4 L7 14';

/**
 * A handwritten-style annotation (Design B) shown under each example card: a small
 * inked arrow pointing at the card and a short gold, italic, slightly-rotated note.
 * The Caveat font from the original mock is approximated with system italic so no
 * new font infra is needed.
 */
export const SketchNote: React.FC<SketchNoteProps> = ({ text, side = 'center' }) => {
  const theme = useTheme();
  const styles = getSketchNoteStyles(theme);
  const isRight = side === 'right';

  return (
    <View style={[styles.row, isRight ? styles.rowRight : styles.rowCenter]}>
      <Svg
        width={30}
        height={32}
        viewBox="0 0 32 36"
        style={[styles.arrow, isRight && styles.arrowMirrored]}
        pointerEvents="none"
      >
        <Path
          d={ARROW_PATH}
          stroke={theme.accent}
          strokeWidth={2.2}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </Svg>
      <Text style={styles.text}>{text}</Text>
    </View>
  );
};
